"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var utilities_1 = require("../../utilities");
var lodash_1 = require("lodash");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var SisNumberSettingsComponent = /** @class */ (function (_super) {
    __extends(SisNumberSettingsComponent, _super);
    function SisNumberSettingsComponent(kbService, communicationService) {
        var _this = _super.call(this, communicationService) || this;
        _this.kbService = kbService;
        _this.communicationService = communicationService;
        _this.step = 1;
        _this.compatibleMetaFields = [];
        _this.isReady = false;
        _this._selectedMetaField = undefined;
        _this.destroySubject$ = new Subject_1.Subject();
        return _this;
    }
    Object.defineProperty(SisNumberSettingsComponent.prototype, "state", {
        set: function (value) {
            if (value['hint'] !== '') {
                this.hint = utilities_1.stringToMultilingual(value['hint']);
            }
            if (value['tooltipSettings']) {
                this._tooltipSettings = idm_ng_controls_1.TooltipSettings.fromJsonString(value['tooltipSettings']);
            }
            if (lodash_1.isFinite(value.step)) {
                this.step = value.step;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisNumberSettingsComponent.prototype, "selectedMetaField", {
        get: function () {
            return this._selectedMetaField;
        },
        set: function (value) {
            this._selectedMetaField = value;
            this.valueChange();
        },
        enumerable: true,
        configurable: true
    });
    SisNumberSettingsComponent.prototype.valueChange = function () {
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            fields: { checkedItem: this._selectedMetaField },
            state: {
                hint: utilities_1.multilingualToString(this.hint),
                step: this.step,
                tooltipSettings: this._tooltipSettings
                    ? this._tooltipSettings.toJsonString()
                    : undefined,
            },
        }));
    };
    SisNumberSettingsComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    SisNumberSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.kbService
            .getMetaFields(this.category)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (metaFields) {
            _this.compatibleMetaFields = metaFields.filter(function (metaField) {
                return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER ||
                    metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DECIMAL;
            });
            if (_this.fields.checkedItem) {
                _this._selectedMetaField = _this.compatibleMetaFields.find(function (f) {
                    return f.getMetaFieldId().getSystemName() ===
                        _this.fields.checkedItem
                            .getMetaFieldId()
                            .getSystemName();
                });
            }
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    SisNumberSettingsComponent.prototype.isValid = function () {
        return !isNaN(this.step) && this.step > 0;
    };
    SisNumberSettingsComponent.prototype.hintChanged = function (hint) {
        this.hint = hint;
        this.valueChange();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNumberSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisNumberSettingsComponent.prototype, "fields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisNumberSettingsComponent.prototype, "state", null);
    SisNumberSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-number-settings',
            template: "\n        <div class=\"sis-form-sidebar__section\" *ngIf=\"isReady\">\n            <div class=\"sis-form-sidebar__label\">\n                {{ 'de.settings.field.binding' | sisTranslate | async }}\n            </div>\n            <sis-combo-box\n                [(value)]=\"selectedMetaField\"\n                [placeHolder]=\"'de_select_one' | sisTranslateMessage | async\"\n            >\n                <sis-select-item\n                    *ngFor=\"let item of compatibleMetaFields\"\n                    [value]=\"item\"\n                    [name]=\"item | sisTranslateDisplayName | async\"\n                >\n                </sis-select-item>\n            </sis-combo-box>\n            <div\n                class=\"sis-form-sidebar__subsection\"\n                [ngClass]=\"{'sis-error-container': !isValid()}\"\n            >\n                <div class=\"sis-form-sidebar__label\">\n                    {{ 'de.settings.number.step' | sisTranslate | async }}\n                </div>\n                <sis-number\n                    [min]=\"0\"\n                    [(value)]=\"step\"\n                    [isReadonly]=\"false\"\n                    [step]=\"0.1\"\n                    (valueChange)=\"valueChange()\"\n                ></sis-number>\n            </div>\n        </div>\n        <sis-ng-hint-settings\n            [(hint)]=\"hint\"\n            [languages]=\"languages\"\n            [currentLanguageId]=\"currentLanguageId\"\n        >\n        </sis-ng-hint-settings>\n        <sis-ng-tooltip-settings\n            [(settings)]=\"tooltipSettings\"\n            [languages]=\"languages\"\n            [currentLanguageId]=\"currentLanguageId\"\n        >\n        </sis-ng-tooltip-settings>\n        <sis-control-label-settings\n            [languages]=\"languages\"\n            [currentLanguageId]=\"currentLanguageId\"\n            [(titleModel)]=\"controlLabel\"\n        >\n        </sis-control-label-settings>\n    ",
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n          <sis-number-settings [category]=\"%{category}\" [fields]=\"%{fields}\" [state]=\"%{state}\"\n                               [languages]=\"%{languages}\" [currentLanguageId]=\"%{currentLanguageId}\"\n                               [controlLabel]=\"%{controlLabel}\">\n          </sis-number-settings>",
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_dynamic_controls_metadata_1.CommunicationService])
    ], SisNumberSettingsComponent);
    return SisNumberSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.SisNumberSettingsComponent = SisNumberSettingsComponent;
//# sourceMappingURL=sis-number-settings.component.js.map